const getRuntimeFeatureOverrides = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  const bootstrapConfig = window.__CBM_BOOTSTRAP_CONFIG__;
  if (bootstrapConfig && typeof bootstrapConfig === 'object') {
    const bootstrapFeatures = bootstrapConfig.features;
    if (bootstrapFeatures && typeof bootstrapFeatures === 'object') {
      return bootstrapFeatures;
    }
  }

  const legacyFeatures = window.__CBM_FEATURES__;
  if (legacyFeatures && typeof legacyFeatures === 'object') {
    return legacyFeatures;
  }

  return {};
};

const runtimeOverrides = getRuntimeFeatureOverrides();

const defaultFeatures = Object.freeze({
  securePackagePages: true,
});

const readFeatureFlag = (name, defaultValue) => {
  const runtimeValue = runtimeOverrides?.[name];
  if (typeof runtimeValue === 'boolean') {
    return runtimeValue;
  }
  return defaultValue;
};

export const features = Object.freeze({
  securePackagePages: readFeatureFlag(
    'securePackagePages',
    defaultFeatures.securePackagePages
  ),
});

export const isFeatureEnabled = (name) => {
  return Boolean(features[name]);
};
